import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getIspuLocatorIframe } from 'app/edozvola/cases/ispu/service/ispu-locator-wrapper.service';
import { toast } from 'react-toastify';
import { showToast } from 'app/shared/util/toast.util';
import { ERRORS, ISPU_LOCATOR_TAB_CLOSE_FLAG } from 'app/config/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { calculateScreenElementsHeight } from 'app/shared/util/screen-utils';
import { Loader } from 'app/shared/loader/loader';
import './ispu-locator-wrapper.scss';

const IspuLocatorWrapper = () => {
  const { entityId, tabName } = useParams<{ tabName: string; entityId: string }>();
  const [isLoading, setLoading] = useState(true);
  const [html, setHtml] = useState<string>('');

  useEffect(() => {
    const sendCloseEvent = () => {
      window.opener.postMessage(ISPU_LOCATOR_TAB_CLOSE_FLAG, '*');
    };

    window.addEventListener('beforeunload', sendCloseEvent);

    return () => window.removeEventListener('beforeunload', sendCloseEvent);
  }, []);

  useEffect(() => {
    if (tabName && entityId) {
      getIspuLocatorIframe(tabName, entityId)
        .then(htmlContent => {
          setHtml(htmlContent);
        })
        .catch(error => {
          if (Object.values(ERRORS).includes(error.detail)) {
            showToast(toast.error, error.detail);
          } else {
            showToast(toast.error, ERRORS.GENERIC_ERROR);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [entityId]);

  useEffect(() => {
    calculateScreenElementsHeight();
  }, [html]);

  const onCloseClicked = () => {
    window.close();
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="max-height">
        <div className="row ispu-locator-header">
          <div className="col-12 col-sm-1">
            <FontAwesomeIcon icon="arrow-left" className="close" onClick={onCloseClicked} />
          </div>
          <div className="col-12 col-sm-5">ISPU Lokator</div>
        </div>
        <iframe id="ispu-locator-iframe" title="Ispu Lokator" className="container-fluid" srcDoc={html} />
      </div>
    </>
  );
};

export default IspuLocatorWrapper;
